import React from "react";

const Authors = () => {
  // These are placeholder names from the mockup
  // In production, this would be fetched from your backend
  const authors = [
    { name: "Saman Attar", url: "https://www.linkedin.com/in/saman-attar/" },
    { name: "Kimberly Small", url: "https://www.linkedin.com/in/kimberlylsmall/" },
    { name: "Opeyemi (Francis) Oni", url: "https://www.linkedin.com/in/oniopeyemifrancis/" },
    { name: "Justin Smith", url: "https://www.linkedin.com/in/justinmsmith1/" },

  ];

  return (
    <div className="space-y-8">
      <div className="text-center mb-12">
        <h2 className="font-['Cabin_Sketch'] text-5xl md:text-6xl text-[#D32F2F] font-bold mb-6 text-shadow-vintage">
          🌟 Challenge Contributors
        </h2>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
        {authors.map((author, index) => {
          const rotation = index % 2 === 0 ? "-rotate-2" : "rotate-2";

          return (
            <a
              key={index}
              href={author.url}
              target="_blank"
              rel="noopener noreferrer"
              className={`group block bg-gradient-to-br from-white to-[#FFF9E6] p-8 rounded-2xl text-center transition-all duration-300 border-3 border-[#FFD700] shadow-lg hover:shadow-2xl hover:scale-105 hover:rotate-0 ${rotation} hover:border-[#D32F2F]`}
            >
              <div className="relative">
                {/* Decorative icon */}
                <div className="text-5xl mb-4 filter drop-shadow-lg group-hover:scale-110 transition-transform duration-300">
                  🎄
                </div>

                {/* Name */}
                <div className="text-[#3E2723] font-bold text-xl md:text-2xl group-hover:text-[#D32F2F] transition-colors duration-300">
                  {author.name}
                </div>

                {/* Hover decoration */}
                <div className="mt-3 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <span className="text-[#FFD700] text-2xl">⭐</span>
                </div>
              </div>
            </a>
          );
        })}
      </div>


      <style jsx>{`
        .text-shadow-vintage {
          text-shadow: 3px 3px 0px #ffd700;
        }

        .border-3 {
          border-width: 3px;
        }

        .drop-shadow-lg {
          filter: drop-shadow(0 0 10px rgba(255, 215, 0, 0.6));
        }
      `}</style>
    </div>
  );
};

export default Authors;
